var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_star_half",
    transform: "translate(-957 -202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M10.368.695,7.927,5.866,2.466,6.7A1.266,1.266,0,0,0,1.8,8.831l3.951,4.023-.935,5.683a1.207,1.207,0,0,0,1.735,1.316l4.886-2.683,4.886,2.683a1.208,1.208,0,0,0,1.735-1.316l-.935-5.683,3.951-4.023A1.266,1.266,0,0,0,20.417,6.7l-5.462-.832L12.514.695A1.175,1.175,0,0,0,10.368.695Z",
    transform: "translate(955.559 202.001)",
    fill: "#dfe3eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uBC18\\uBCF5_\\uADF8\\uB9AC\\uB4DC_19",
    "data-name": "\\uBC18\\uBCF5 \\uADF8\\uB9AC\\uB4DC 19",
    transform: "translate(957 202)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-957 -202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ico_star",
    d: "M10.369.695,7.927,5.866,2.466,6.7A1.266,1.266,0,0,0,1.8,8.831l3.951,4.023-.935,5.683a1.207,1.207,0,0,0,1.735,1.316l4.886-2.683,4.886,2.683a1.208,1.208,0,0,0,1.735-1.316l-.935-5.683,3.951-4.023A1.266,1.266,0,0,0,20.417,6.7l-5.462-.832L12.514.695A1.175,1.175,0,0,0,10.369.695Z",
    transform: "translate(955.559 202.001)",
    fill: "#6aace9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar05);
export default __webpack_public_path__ + "static/media/star_0.5.0fa78bedfe09df63baffcf47e430214e.svg";
export { ForwardRef as ReactComponent };